import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Star, UtensilsCrossed } from 'lucide-react';
import { Button } from '../ui/button';
import { restaurantInfo } from '../../data/mock';
import ResponsiveImage from '../ResponsiveImage';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-[#FFFBF5] pt-20 overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-32 left-10 w-24 h-24 rounded-full bg-[#1B4332]/5" />
      <div className="absolute bottom-20 right-10 w-40 h-40 rounded-full bg-[#C67C4E]/10" />
      <div className="absolute top-1/3 right-1/4 w-16 h-16 rounded-full bg-[#1B4332]/5" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="text-center lg:text-left animate-fadeInUp">
            <div className="inline-flex items-center gap-2 bg-[#1B4332]/10 rounded-full px-4 py-2 mb-6">
              <Star size={16} className="text-[#C67C4E] fill-[#C67C4E]" />
              <span className="text-sm font-medium text-[#1B4332]">
                {restaurantInfo.googleRating} Stars on Google
              </span>
            </div>

            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold text-[#1B4332] mb-6 leading-tight">
              Welcome To<br />
              <span className="italic text-[#C67C4E]">La Pasteria</span>
            </h1>

            <p className="text-lg sm:text-xl text-[#636E72] mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              {restaurantInfo.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link to="/booking">
                <Button className="btn-terracotta text-lg px-8 py-4 h-auto">
                  Book a Table
                  <ChevronRight size={20} className="ml-2" />
                </Button>
              </Link>
              <Link to="/menu">
                <Button variant="outline" className="btn-secondary text-lg px-8 py-4 h-auto">
                  View Menu
                  <UtensilsCrossed size={20} className="ml-2" />
                </Button>
              </Link>
            </div>

            {/* Reviews Badge */}
            <div className="mt-10 flex items-center gap-6 justify-center lg:justify-start">
              <a
                href={restaurantInfo.googleReviewsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#2D3436] hover:text-[#C67C4E] transition-colors"
              >
                <div className="flex">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={`hero-rating-star-${i}`}
                      size={18}
                      className="text-[#C67C4E] fill-[#C67C4E]"
                    />
                  ))}
                </div>
                <span className="font-medium">{restaurantInfo.googleReviewCount}+ Reviews</span>
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="relative animate-slideInRight delay-200">
            <div className="relative z-10 rounded-3xl overflow-hidden bg-[#F5EFE7] aspect-square max-w-lg mx-auto shadow-2xl">
              <ResponsiveImage
                basePath="/images/hero"
                alt="Delicious Pizza"
                fetchPriority="high"
                loading="eager"
                sizes="(max-width: 768px) 100vw, 512px"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-full h-full bg-[#1B4332] rounded-3xl -z-0 max-w-lg mx-auto" />
            <div className="absolute -bottom-8 -left-8 bg-[#C67C4E] rounded-2xl p-4 shadow-xl z-20 animate-pulse-gentle">
              <p className="font-serif text-lg font-semibold text-white">Authentic Italian</p>
              <p className="text-sm text-white/80">Since 2023</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
